export const templates_insights = {
    results(iteratedResults, resultsClass) {
        return `
          <div class="${resultsClass}">
              ${iteratedResults}
          </div>
      `;
    },
    result(data, eventClass) {
        if (data.disp.listMetadata && data.disp.listMetadata.pageType[0]) {
            return `
            <li>
            <a href="${
                data.action
                    ? data.action
                    : data.disp.displayUrl
            }" class="fbac__result ${eventClass}">
              ${data.disp.title}
              <span>${data.disp.listMetadata.pageType[0].replace(
                  /Insight -/gi,
                  "Insights /"
              )}</span>
            </a>
            </li>
          `;
        }
        return "";
    },
    noResults(query) {
        return `
          <div class="fbac__results">
              <div class="fbac__no-result">
                  No results were found for <i>${query}</i>.
              </div>
          </div>
      `;
    },
};

export const templates_news_insights = {
    results(iteratedResults, resultsClass) {
        return `
          <div class="${resultsClass}">
              ${iteratedResults}
          </div>
      `;
    },
    result(data, eventClass) {
        if (data.disp.listMetadata && data.disp.listMetadata.pageType[0]) {
            const date = new Date(data.disp.date); // Convert timestamp to Date object

            const formattedDate = date?.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
            });

            return `
            <li>
            <a href="${
                data.action
                    ? data.action
                    : data.disp.displayUrl
            }" class="fbac__result ${eventClass}">
              ${data.disp.title}
              <span>${formattedDate}</span>
            </a>
            </li>
          `;
        }
        return "";
    },
    noResults() {
        return `
          <div class="fbac__results">
              <div class="fbac__no-result">
                  No matching results - <a href="/search">see all results page</a>
              </div>
          </div>
      `;
    },
};

export const templates_meta_autocomplete = {
    results(iteratedResults, resultsClass) {
        return `
          <ul class="concierge__autocomplete ${resultsClass}">
              ${iteratedResults}
          </ul>
      `;
    },
    result(data, eventClass) {
        return `
            <li class="fbac__result-wrapper">
                <a href="#" class="fbac__result ${eventClass}">
                    ${data.disp}
                </a>
            </li>
        `;
    },
    noResults() {
        return ``;
    },
};

export const templates_solutions = {
    results(iteratedResults, resultsClass) {
        return `
          <div class="${resultsClass}">
              ${iteratedResults}
          </div>
      `;
    },
    result(data, eventClass) {
        if (data.disp.listMetadata && data.disp.listMetadata.pageType[0]) {
            return `
            <li>
            <a href="${
                data.action
                    ? data.action
                    : data.disp.displayUrl
            }" class="fbac__result ${eventClass}">
              ${data.disp.title}
              <span>Solutions / ${data.disp.listMetadata.pageType[0]}</span>
            </a>
            </li>
          `;
        }
        return "";
    },
    noResults(query) {
        return `
          <div class="fbac__results">
              <div class="fbac__no-result">
                  No results were found for <i>${query}</i>.
              </div>
          </div>
      `;
    },
};

export const templates_solutions_careers = {
    results(iteratedResults, resultsClass) {
        return `
          <div class="${resultsClass}">
              ${iteratedResults}
          </div>
      `;
    },
    result(data, eventClass) {
        if (data.disp.listMetadata && data.disp.listMetadata.pageType[0]) {
            return `
            <li>
            <a href="${
                data.action
                    ? data.action
                    : data.disp.displayUrl
            }" class="fbac__result ${eventClass}">
              ${data.disp.title}
              <span>Solutions / ${data.disp.listMetadata.pageType[0].replace(
                  " - ",
                  " / "
              )}</span>
            </a>
            </li>
          `;
        }
        return "";
    },
    noResults() {
        return `
          <div class="fbac__results">
              <div class="fbac__no-result">
                No matching results - <a href="/search">see all results page</a>
              </div>
          </div>
      `;
    },
};

export const templates_news = {
    results(iteratedResults, resultsClass) {
        return `
          <div class="${resultsClass}">
              ${iteratedResults}
          </div>
      `;
    },
    result(data, eventClass) {
        if (data.disp.listMetadata && data.disp.listMetadata.pageType[0]) {
            const date = new Date(data.disp.date);

            const formattedDate = date?.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
            });

            return `
            <li>
              <a href="${
                  data.action
                      ? data.action
                      : data.disp.displayUrl
              }" class="fbac__result ${eventClass}">
                ${data.disp.title}
                <span>${formattedDate}</span>
              </a>
              </li>
          `;
        }
        return "";
    },
    noResults(query) {
        return `
          <div class="fbac__results">
              <div class="fbac__no-result">
                  No results were found for <i>${query}</i>.
              </div>
          </div>
      `;
    },
};

export const templates_careers = {
    results(iteratedResults, resultsClass) {

        return `
          <div class="${resultsClass}">
              ${iteratedResults}
          </div>
      `;
    },
    result(data, eventClass) {
        if (data.disp.listMetadata && data.disp.listMetadata.pageType[0]) {
            return `
            <li>
            <a href="${
                data.action
                    ? data.action
                    : data.disp.displayUrl
            }" class="fbac__result ${eventClass}">
              ${data.disp.title}
              <span>${data.disp.listMetadata.pageType[0]
                  .replace(/.* - /i, "")
                  .replace("Life@wood blog", "Life at wood stories")}</span>
            </a>
            </li>
          `;
        }
        return "";
    },
    noResults(data) {
        console.log(data);
        return `
          <div class="fbac__results">
              <div class="fbac__no-result">
                No matching resultss - <a href="/search">see all results page</a>
              </div>
          </div>
      `;
    },
};
